import api from './api';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// ── Photos (owner) ────────────────────────────────────────────
export const uploadPetPhoto = (petId, formData) =>
  api.post(`/api/pet-media/${petId}/photos`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

export const getPetPhotos = petId =>
  api.get(`/api/pet-media/${petId}/photos`);

export const getPublicPetPhotos = petId =>
  api.get(`/api/pet-media/${petId}/photos/public`);

export const updatePetPhoto = (petId, mediaId, data) =>
  api.patch(`/api/pet-media/${petId}/photos/${mediaId}`, data);

export const deletePetPhoto = (petId, mediaId) =>
  api.delete(`/api/pet-media/${petId}/photos/${mediaId}`);

// ── Photo URL helpers ─────────────────────────────────────────
// Use these to build src= URLs — they go through the authenticated endpoint
export const photoUrl     = filename => `${BASE}/api/pet-media/file/photo/${filename}`;
export const thumbUrl     = filename => `${BASE}/api/pet-media/file/thumbnail/${filename}`;
export const publicPhotoUrl = filename => `${BASE}/api/pet-media/public/photo/${filename}`;
export const publicThumbUrl = filename => `${BASE}/api/pet-media/public/thumbnail/${filename}`;

// ── Documents (owner) ─────────────────────────────────────────
export const uploadOwnerDocument = (petId, formData) =>
  api.post(`/api/pet-media/${petId}/documents/owner`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

export const getPetDocuments = petId =>
  api.get(`/api/pet-media/${petId}/documents`);

export const deleteDocument = (petId, mediaId) =>
  api.delete(`/api/pet-media/${petId}/documents/${mediaId}`);

export const approveProvider = (petId, mediaId, providerId) =>
  api.post(`/api/pet-media/${petId}/documents/${mediaId}/approve/${providerId}`);

export const revokeProvider = (petId, mediaId, providerId) =>
  api.delete(`/api/pet-media/${petId}/documents/${mediaId}/approve/${providerId}`);

// ── Documents (provider) ─────────────────────────────────────
export const uploadProviderDocument = (petId, formData) =>
  api.post(`/api/pet-media/${petId}/documents`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

export const getProviderDocuments = petId =>
  api.get(`/api/pet-media/${petId}/documents/provider`);

// ── Document URL ──────────────────────────────────────────────
export const documentUrl = filename => `${BASE}/api/pet-media/file/document/${filename}`;
